import React, { useState } from "react";
import Header from "../common/Header";
import Footer from "../common/Footer";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import axiosInstance from "../axiosInstance";
import ExternalScripts from "../common/ExternalScripts";
import toast from "react-hot-toast";

const Login = () => {
  const [obj,setObj] = useState({email:"",password:""})
  const [loading,setLoading] = useState(false)
  const [remember,setRemember] = useState(false)
  const [error,setError] = useState("")
  const [otp,setOtp] = useState("")
  const [renderOtp,setRenderOtp] = useState(false)
  const navigate = useNavigate()
  const set = (event) => {
    const {name,value} = event.target
    setObj({...obj,[name]:value})
  }
  const handleSubmit = async(e) => {
    try {
      toast.loading("wait logging...")

      e.preventDefault()
      setError("")
      setLoading(true)
      const response = await axiosInstance.post("/api/auth/loginUser",obj)
      if(response.status === 200 && response?.data?.status===true){
        toast.success(response?.data?.message)
        localStorage.setItem("auth",JSON.stringify({token:response?.data?.token,remember}))
        setRenderOtp(true)
      }
      if(response.status === 202 && response?.data?.status===true){
        toast.success(response?.data?.message)
        localStorage.setItem("auth",JSON.stringify({token:response?.data?.token,remember}))
        navigate("/Dashboard")
      }
      
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          const msg = error.response.data?.message || error.response.data?.error || "Something went wrong on the server.";
          setError(msg);
        }
        else if (error.request) {
          setError("No response from server. Please check your internet connection.");
        }
        else {
          setError(error.message || "Unexpected error occurred.");
        }
      } else {
        setError("An unexpected error occurred.");
      }
    } finally{
      setLoading(false)
    }
  }
  const handleSubmitViaOtp = async(e) => {
    try {
      toast.loading("wait logging...")
      e.preventDefault()
      setError("")
      setLoading(true)
      const auth = JSON.parse(localStorage.getItem("auth"))
      if(!auth || !auth?.token){
        setRenderOtp(false)
        setObj({email:"",password:""})
      }
      const response = await axiosInstance.post("/api/auth/verifyUser",{otp},{headers:{
        "Authorization":auth.token
      }})
      if(response.status === 202){
        toast.success(response?.data?.message)
        navigate("/Dashboard")
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          const msg = error.response.data?.message || error.response.data?.error || "Something went wrong on the server.";
          setError(msg);
        }
        else if (error.request) {
          setError("No response from server. Please check your internet connection.");
        }
        else {
          setError(error.message || "Unexpected error occurred.");
        }
      } else {
        setError("An unexpected error occurred.");
      }
    } finally{
      setLoading(false)
    }
  }
  return (
    <div className="boxcar-wrapper" style={{backgroundColor:"#050B20"}}>
      <ExternalScripts/>
      <div style={{marginBottom:"120px"}} >
      <Header preclass="normal" />
      </div>
      <section style={{ marginTop:"0px",borderRadius:"0px",zIndex:999,}} className="login-section layout-radius bg-Image">
      {/* <div className="row"> */}
      {/* <div className="col-lg-6"> */}
        <div   style={{backgroundColor:"white"}} className="inner-container login-inner">
          <div className="right-box">
            <div className="form-sec">
              <nav>
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                  <button
                    className="nav-link active"
                    id="nav-home-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-home"
                    type="button"
                    role="tab"
                    aria-controls="nav-home"
                    aria-selected="true"
                  >
                    Sign in
                  </button>
                </div>
              </nav>
              <div className="tab-content" id="nav-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="nav-home"
                  role="tabpanel"
                  aria-labelledby="nav-home-tab"
                >
                  {renderOtp?<div className="form-box two">
                    <form>
                      <div className="form_boxes">
                        <label>OTP (One-Time-Password)</label>
                        <input type="number" name="otp" value={otp} onChange={(e)=>setOtp(e.target.value)} placeholder={"Enter Otp"} />
                      </div>
                      {error && <p style={{fontSize:"18px",color:"red"}}>{error}</p>}
                      <div className="form-submit">
                        <button disabled={loading} onClick={handleSubmitViaOtp} type="submit" className="theme-btn">
                          {loading?"Submitting...":"Submit"} <img src="images/arrow.svg"   />
                        </button>
                      </div>
                    </form>
                  </div>:<div className="form-box">
                    <form>
                      <div className="form_boxes">
                        <label>Email</label>
                        <input
                          type="email"
                          name="email"
                          placeholder="*********@gmail.com"
                          value={obj.email}
                          onChange={set}
                        />
                      </div>
                      <div className="form_boxes">
                        <label>Password</label>
                        <input
                          type="password"
                          name="password"
                          onChange={set}
                          value={obj.password}
                          placeholder="********"
                        />
                      </div>
                      <div className="btn-box">
                        <label className="contain">
                          Remember
                          <input onClick={()=>setRemember(!remember)} type="checkbox" defaultChecked={remember} />
                          <span className="checkmark" />
                        </label>
                        <a href="#" className="pasword-btn">
                          Forgotten password?
                        </a>
                      </div>
                      {error && <p style={{fontSize:"18px",color:"red"}}>{error}</p>}
                      <div className="form-submit">
                        <button onClick={handleSubmit} disabled={loading} type="submit" className="theme-btn">
                          {loading?"Processing...":"Login"} <img src="images/arrow.svg"   />
                        </button>
                      </div>
                    </form>
                  </div>}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
      {/* <div className="col-lg-6 "> */}
        {/* <img src="" alt="" /> */}
        {/* </div> */}
        {/* </div> */}
      </section>
      <Footer />
    </div>
  );
};

export default Login;
